'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');

const COLUMN_SIZES = [
    'col-span-1',
    'col-span-2',
    'col-span-3',
    'col-span-4',
    'col-span-5',
    'col-span-6',
    'col-span-7',
    'col-span-8',
    'col-span-9',
    'col-span-10',
    'col-span-11'
];
/**
 * 그리드 시스템 기반의 컬럼 레이아웃 컴포넌트
 * @param {Object} props
 * @param {boolean} [props.container] - 컨테이너 여부
 * @param {number} [props.size] - 컬럼 크기 (1-11)
 * @param {number} [props.leftColumnSize] - 왼쪽 컬럼 크기
 * @param {number} [props.centerColumnSize] - 가운데 컬럼 크기
 * @param {number} [props.rightColumnSize] - 오른쪽 컬럼 크기
 * @param {string} [props.className] - 추가적인 CSS 클래스
 */ const Column = ({ container = false, size = 1, className, children })=>{
    if (container) return jsxRuntime.jsx("div", {
        "data-testid": "design-system-column--container",
        className: tailwindMerge.twMerge('grid auto-cols-1fr grid-flow-col', className),
        children: children
    });
    const generateColumnSize = (size)=>COLUMN_SIZES[size - 1];
    return jsxRuntime.jsx("div", {
        "data-testid": "design-system-column",
        className: tailwindMerge.twMerge(generateColumnSize(size), className),
        children: children
    });
};

module.exports = Column;
